import { css } from '@emotion/css';
import { AlignItems, BorderRadius, Color, Display, Font, Spacing } from 'src/styles';

export const closedOfferBadge = css`
  ${Font.lg}
  color: ${Color.Gray8};
  ${Spacing.mb32}
  background: ${Color.Red1};
  ${Spacing.p16}
  ${BorderRadius.xs}
`;

export const closedOfferTitle = css`
  && {
    ${Display.flex}
    ${AlignItems.center}
  }
`;

export const closedOfferParagraph = css`
  ${Spacing.mt8}
`;
